import { createAction } from 'redux-actions'

import * as types from './types'

export const getWaterUtility = createAction(types.GET_WATER_UTILITY)
